import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard } from 'src/app/core/guards/authorize.guard';
import { RightsGuard } from 'src/app/core/guards/rights.guard';
import { InsuranceDetailComponent } from './insurance-detail/insurance-detail.component';
import { InsurancesListComponent } from './insurances-list/insurances-list.component';

const routes: Routes = [
  {
    path: 'insurances',
    canActivate: [AuthorizeGuard, RightsGuard],
    children: [
      { path: '', component: InsurancesListComponent },
      { path: ':insuranceId', component: InsuranceDetailComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class InsuranceRoutingModule {}
